import {createStateMaker} from '@shared/helpers/object'

import {APIStatus} from '@web/core/constants'

import {AdStatus, RecommendationProductState} from '../interfaces'

export const getInitialState = (): RecommendationProductState => {
    return {
        products: [],
        waterfallResponse: null,
        apiStatus: APIStatus.IDLE,
        adStatus: AdStatus.IDLE,
    }
}

export const makeMock = createStateMaker<RecommendationProductState>(getInitialState)
